/**
 * `/activa/oficial/conversaciones` sin ninguna abierta. En la computadora ocupa el lugar del hilo, al lado
 * de la lista; en el celular (y hasta `xl`) el layout lo oculta: ahí la lista ocupa la pantalla.
 */

import { MessagesSquare } from "lucide-react";

export default function ConversacionesIndexPage() {
  return (
    <div className="rounded-2xl border-2 border-dashed border-slate-200 p-10 text-center text-sm text-slate-500">
      <MessagesSquare size={22} className="mx-auto text-slate-300" />
      <p className="mt-3">Elegí una conversación de la lista para ver todo lo que se habló y contestar.</p>
    </div>
  );
}
